// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2022-02-17 23:43:24 +0100 (Thu, 17 Feb 2022) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 125431 $
//  Purpose   : configure db fields/columns for type if listing children in dashboard
// =============================================================================
// ---Third-party imports

// ---Framework imports
import log from 'uix/logging'

// ---Globals
const WIKI_FOLDER = {
  //~ childTypes: ['webpage', 'wikifolder'],
  columns: {
    reduced: ['release.value', 'ow.ident'],
    default: ['release.value', 'ow.ident', 'ow.state', 'ow.mimetype'],
  },
}

// rules
const LIST_RULES = {
  metadata: {},
  substructure: {},
  wiki_domain_container: WIKI_FOLDER,
  wikifolder: WIKI_FOLDER,
}

// ---Exports
export const getColumnSet = (name, typeName) => {
  let colsets = LIST_RULES[typeName]?.columns
  return colsets?.[name] || []
}
